"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1061],{

/***/ 56202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ AddToCartButton; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/elements/esm/index.js + 103 modules
var esm = __webpack_require__(12601);
// EXTERNAL MODULE: ../node_modules/twind/twind.js + 1 modules
var twind = __webpack_require__(34209);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ./utils/isTouchScreenDevice.ts
var isTouchScreenDevice = __webpack_require__(41332);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
;// CONCATENATED MODULE: ./hooks/useBranchFeature.ts






var qrCodeSettings = {
    code_color: "#000000",
    background_color: "#FFFFFF",
    margin: 2,
    width: 380,
    image_format: "png"
};
var useBranchFeature = function() {
    var ref = (0,react.useState)({
        appLink: null,
        qrCode: null
    }), redirectToApp = ref[0], setRedirectToApp = ref[1];
    var branchAnalyticsData = (0,useSiteConfig/* useSiteConfig */.N)().branchAnalyticsData;
    var router = (0,next_router.useRouter)();
    var isMobile = (0,isTouchScreenDevice/* isTouchScreenDevice */.S)();
    (0,react.useEffect)(function() {
        if (!window.branch) return;
        var asPath = router.asPath, query = router.query;
        var linkData = {
            data: {
                $canonical_url: "https://".concat(query.country, ".puma.com").concat(asPath),
                $canonical_identifier: "product-id-".concat(query.id, "/").concat(query.model, "/swatch-").concat(query.swatch),
                "~agency_id": branchAnalyticsData === null || branchAnalyticsData === void 0 ? void 0 : branchAnalyticsData.agencyId
            }
        };
        if (isMobile) {
            window.branch.link(linkData, function(err, link) {
                if (!err) {
                    setRedirectToApp(function(prevState) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                            appLink: link
                        });
                    });
                } else {
                    // eslint-disable-next-line no-console
                    console.error(err);
                }
            });
        } else {
            window.branch.qrCode(linkData, qrCodeSettings, function(err, qrCode) {
                try {
                    var base64 = qrCode.base64();
                    setRedirectToApp(function(prevState) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                            qrCode: base64
                        });
                    });
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error(err || error);
                }
            });
        }
        return function() {
            return setRedirectToApp({
                appLink: null,
                qrCode: null
            });
        };
    }, [
        router,
        isMobile,
        branchAnalyticsData === null || branchAnalyticsData === void 0 ? void 0 : branchAnalyticsData.agencyId
    ]);
    return redirectToApp;
};

// EXTERNAL MODULE: ./ui/components/Modal.tsx
var Modal = __webpack_require__(51377);
// EXTERNAL MODULE: ./ui/components/CloseButton.tsx
var CloseButton = __webpack_require__(6485);
;// CONCATENATED MODULE: ./ui/components/ScanQrCodeModal.tsx






var ScanQRCodeModal = function(param) {
    var onClickOutside = param.onClickOutside;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var qrCode = useBranchFeature().qrCode;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        dataTestId: "scan-qr-modal",
        variant: "dark",
        onClickOutside: onClickOutside,
        className: "flex flex-col justify-center items-center w-full max-w-[596px] px-8 relative py-10 text-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* default */.Z, {
                className: "absolute right-5 top-5 z-50",
                onClick: onClickOutside
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-3xl font-bold uppercase mb-4",
                        children: t("scanQRCode")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: t("pointYourCamera")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col justify-center items-center w-96 h-96 border-2 border-solid border-neutral-100 mb-8 relative",
                children: [
                    qrCode && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "relative z-10",
                        src: "data:image/png;charset=utf-8;base64,".concat(qrCode),
                        width: "380",
                        height: "380",
                        alt: "QR Code"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "absolute w-[352px] h-[384px] top-1/2 left-1/2 bg-white -translate-1/2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "absolute w-[384px] h-[352px] top-1/2 left-1/2 bg-white -translate-1/2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-sm text-neutral-60",
                children: t("augmentedRealityRequires")
            })
        ]
    });
};

// EXTERNAL MODULE: ./ui/elements/Link.tsx
var Link = __webpack_require__(68302);
;// CONCATENATED MODULE: ./ui/elements/PurchaseOnAppCta.tsx








var PurchaseOnAppCta = function(param) {
    var className = param.className, size = param.size;
    var ref = (0,react.useState)(false), isOpenModal = ref[0], setIsOpenModal = ref[1];
    var t = (0,useTranslations/* useTranslate */.qM)();
    var appLink = useBranchFeature().appLink;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                className: (0,twind.tw)("hidden mobile:flex tablet:flex", className),
                dataTestId: "purchase-on-app-link",
                href: appLink,
                height: size === "lg" ? "tall" : undefined,
                as: "button",
                variant: "black",
                newtab: true,
                children: t("purchaseOnApp")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                className: (0,twind.tw)("tablet:hidden mobile:hidden", className),
                dataTestId: "purchase-on-app-button",
                label: t("purchaseOnApp"),
                onClick: function() {
                    return setIsOpenModal(true);
                },
                size: size,
                variant: "primary"
            }),
            isOpenModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScanQRCodeModal, {
                onClickOutside: function() {
                    return setIsOpenModal(false);
                }
            })
        ]
    });
};

// EXTERNAL MODULE: ./hooks/useStickyButton.tsx
var useStickyButton = __webpack_require__(77313);
// EXTERNAL MODULE: ./utils/isAppExclusiveValidRange.ts
var isAppExclusiveValidRange = __webpack_require__(22649);
;// CONCATENATED MODULE: ./ui/components/AddToCartButton.tsx








var AddToCartButton = function(param) {
    var className = param.className, disabled = param.disabled, isAppExclusive = param.isAppExclusive, loading = param.loading, onAddToCart = param.onAddToCart, outOfStock = param.outOfStock, _presale = param.presale, presale = _presale === void 0 ? false : _presale, size = param.size, appOnlyDateTimeFrom = param.appOnlyDateTimeFrom, appOnlyDateTimeTo = param.appOnlyDateTimeTo;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref = (0,react.useRef)(null);
    (0,useStickyButton/* useStickyButtonIntersection */.Yl)(ref); // default threshold 0 → hide sticky as soon as any part of main button is visible
    if ((0,isAppExclusiveValidRange/* isAppExclusiveValidRange */.o)(isAppExclusive, appOnlyDateTimeFrom, appOnlyDateTimeTo)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseOnAppCta, {
            className: className,
            size: size
        });
    }
    if (outOfStock) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            "data-test-id": "out-of-stock-message",
            className: (0,twind.tw)(className, "mt-4 flex items-center space-x-3 justify-between text-puma-red border border-puma-red font-bold px-3 py-2 text-sm rounded mb-2"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: t("selectedSizeIsNotOrderable")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                    name: "exclamation-outline",
                    size: "2xl"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
            dataTestId: "add-to-cart-button",
            loading: loading,
            variant: "primary",
            className: className,
            disabled: disabled || loading,
            onClick: onAddToCart,
            label: presale ? t("preOrder") : t("addToCart"),
            size: size,
            ref: ref
        })
    });
};


/***/ }),

/***/ 41347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ GWPNewDesign; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/elements/esm/index.js + 103 modules
var esm = __webpack_require__(12601);
// EXTERNAL MODULE: ./store/index.ts + 5 modules
var store = __webpack_require__(57023);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(19989);
// EXTERNAL MODULE: ../node_modules/twind/css/css.js
var css = __webpack_require__(49224);
// EXTERNAL MODULE: ../node_modules/twind/style/style.js
var style = __webpack_require__(79200);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/hooks/esm/index.js
var hooks_esm = __webpack_require__(68138);
;// CONCATENATED MODULE: ./UDS/elements/action-cta/useActionCta.tsx
// @ts-nocheck
// no check with TS because this file is cloned from the UDS repo - we are going to use this file from the UDS repo coming soon


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      &::after {\n        content: '';\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var ctaStyle = (0,style/* style */.oB)({
    base: "pointer-events-all relative inline-flex whitespace-normal items-center justify-center h-10 min-w-max border-1 text-white bg-neutral-100 border-neutral-100 hover:(bg-neutral-80 border-neutral-80) focus-visible:(bg-neutral-80 border-neutral-80 ring-0 outline-none)",
    variants: {
        /**
     * Choose one of the core CTA styles.
     *
     * - primary: a solid rectangle
     * - secondary: outline rectangle
     * - ghost: transparent rectangle
     * - underline: deprecated - use `ButtonUnderline` or `ButtonText` instead
     *
     * @defaultValue primary
     *
     * @example
     * ```
     * <ButtonCta variant="primary" label="Shop Running" />
     * ```
     */ variant: {
            primary: "text-white bg-neutral-100 border-neutral-100 hover:(bg-neutral-80 border-neutral-80) focus-visible:(bg-neutral-80 border-neutral-80)",
            secondary: "text-neutral-100 border-neutral-40 bg-transparent hover:(bg-transparent border-neutral-100) focus-visible:(bg-transparent border-neutral-100)",
            ghost: "bg-neutral-100 border-transparent bg-opacity-0 text-neutral-100 hover:(border-transparent bg-opacity-20) focus-visible:(border-transparent bg-opacity-20)",
            underline: "h-auto rounded-none border-0 bg-transparent border-transparent text-neutral-100 hover:(bg-transparent) focus-visible:(bg-transparent)"
        },
        /**
     * Use to render elements on dark backgrounds
     *
     * @defaultValue false
     *
     * @example
     * ```
     * <ButtonCta
     *   variant="primary"
     *   label="Shop Running"
     *   invert={true}
     * />
     * ```
     */ invert: {
            true: "bg-white border-white text-neutral-100 hover:(bg-neutral-20 border-neutral-20) focus-visible:(bg-neutral-20 border-neutral-20)",
            false: ""
        },
        /**
     * Set rounded corners
     *
     * @defaultValue false
     */ round: {
            true: "rounded-full",
            false: "rounded-sm"
        },
        /**
     * Set to full width
     *
     * @defaultValue false
     */ bleed: {
            true: "w-full",
            false: ""
        },
        /**
     * Semantic color property. Currently only supports `brand`
     */ color: {
            default: "",
            brand: "bg-brand-60  border-brand-60 text-white hover:(border-neutral-80 bg-neutral-80) focus-visible:(border-neutral-80 bg-neutral-80)"
        },
        /**
     * Set the element size.
     *
     * @defaultValue base
     */ size: {
            sm: "h-8 px-3",
            base: "h-10 px-4",
            lg: "h-14 px-6"
        },
        /**
     * The mode of the button
     * - text: renders a text button
     * - icon: renders an icon button
     *
     * @defaultValue text
     *
     * @deprecated use `ButtonIcon` instead for icon buttons
     */ mode: {
            icon: "px-0 w-10 h-10 rounded-full",
            text: ""
        },
        dimmed: {
            true: "cursor-not-allowed",
            false: "cursor-pointer"
        },
        loading: {
            true: "cursor-not-allowed",
            false: "cursor-pointer"
        }
    },
    matches: [
        {
            mode: "icon",
            size: "sm",
            use: "w-8 h-8"
        },
        {
            mode: "icon",
            size: "base",
            use: "w-10 h-10"
        },
        {
            mode: "icon",
            size: "lg",
            use: "w-14 h-14 px-0"
        },
        {
            variant: "underline",
            use: "px-0"
        },
        {
            variant: "underline",
            mode: "icon",
            size: "sm",
            use: "w-4 h-6"
        },
        {
            variant: "underline",
            mode: "icon",
            size: "base",
            use: "w-6 h-6"
        },
        {
            variant: "underline",
            mode: "icon",
            size: "lg",
            use: "w-8 h-6"
        },
        {
            variant: "primary",
            dimmed: true,
            use: "bg-neutral-30 border-neutral-30 text-neutral-80 hover:(bg-neutral-30 border-neutral-30) focus-visible:(bg-neutral-30 border-neutral-30)"
        },
        {
            variant: "primary",
            dimmed: true,
            invert: true,
            use: "bg-neutral-30 border-neutral-30 text-neutral-80 hover:(bg-neutral-30 border-neutral-30) focus-visible:(bg-neutral-30 border-neutral-30)"
        },
        {
            variant: "secondary",
            invert: true,
            use: "bg-transparent border-neutral-60 text-white hover:(border-white bg-transparent) focus-visible:(border-white bg-transparent)"
        },
        {
            variant: "secondary",
            dimmed: true,
            use: "bg-transparent text-neutral-60 border-current hover:(bg-transparent border-current) focus-visible:(bg-transparent border-current)"
        },
        {
            variant: "secondary",
            dimmed: true,
            invert: true,
            use: "bg-transparent text-neutral-50 border-current hover:(bg-transparent border-current) focus-visible:(bg-transparent border-current)"
        },
        {
            variant: "ghost",
            invert: true,
            use: "bg-neutral-0 bg-opacity-0 border-transparent text-neutral-10 hover:(border-transparent bg-opacity-20) focus-visible:(border-transparent bg-opacity-20)"
        },
        {
            variant: "ghost",
            dimmed: true,
            invert: false,
            use: "bg-neutral-0 bg-opacity-0 border-transparent text-neutral-60 hover:bg-transparent focus-visible:bg-transparent"
        },
        {
            variant: "ghost",
            dimmed: true,
            invert: true,
            use: "bg-neutral-0 bg-opacity-0 border-transparent text-neutral-50 hover:bg-transparent focus-visible:bg-transparent"
        },
        {
            color: "brand",
            invert: true,
            use: "bg-brand-60 border-brand-60 text-white hover:(border-neutral-80 bg-neutral-80) focus-visible:(border-neutral-80 bg-neutral-80)"
        },
        {
            color: "brand",
            dimmed: true,
            use: "bg-neutral-30 border-neutral-30 text-neutral-80 hover:(bg-neutral-30 border-neutral-30) focus-visible:(bg-neutral-30 border-neutral-30)"
        },
        {
            variant: "underline",
            invert: true,
            use: "bg-transparent border-none text-white hover:(bg-transparent border-transparent) focus-visible:(bg-transparent border-transparent)"
        },
        {
            variant: "underline",
            dimmed: true,
            use: "bg-transparent border-none text-neutral-50 hover:(bg-transparent border-transparent) focus-visible:(bg-transparent border-transparent)"
        }, 
    ],
    defaults: {
        variant: "primary",
        size: "base",
        color: "default",
        round: false
    }
});
var iconSizeMap = {
    sm: "base",
    base: "2xl",
    lg: "4xl"
};
var getIconSizeByActionSize = function(size) {
    var iconSize;
    if (typeof size === "string") {
        iconSize = iconSizeMap[size];
    } else {
        iconSize = Object.assign({});
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.entries(size)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), key = _value[0], value = _value[1];
                iconSize[key] = iconSizeMap[value];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return iconSize;
};
var useActionCta_useActionCta = function(param) {
    var className = param.className, label = param.label, srOnlyLabel = param.srOnlyLabel, _variant = param.variant, variant = _variant === void 0 ? "primary" : _variant, _invert = param.invert, invert = _invert === void 0 ? false : _invert, _round = param.round, round = _round === void 0 ? false : _round, _bleed = param.bleed, bleed = _bleed === void 0 ? false : _bleed, _size = param.size, size = _size === void 0 ? "base" : _size, _color = param.color, color = _color === void 0 ? "default" : _color, _mode = param.mode, mode = _mode === void 0 ? "text" : _mode, _dimmed = param.dimmed, dimmed = _dimmed === void 0 ? false : _dimmed, dimmedReason = param.dimmedReason, icon = param.icon, iconEnd = param.iconEnd, loading = param.loading, _uppercase = param.uppercase, uppercase = _uppercase === void 0 ? true : _uppercase, _bold = param.bold, bold = _bold === void 0 ? true : _bold, _underlineSizeInPx = param.underlineSizeInPx, underlineSizeInPx = _underlineSizeInPx === void 0 ? "2px" : _underlineSizeInPx;
    var t = (0,hooks_esm/* useUdsTranslate */.oG)();
    var actionClassName = (0,style.tw)("group", ctaStyle({
        variant: variant,
        invert: invert,
        size: size,
        round: round,
        bleed: bleed,
        color: color,
        mode: mode,
        dimmed: dimmed,
        loading: loading
    }), iconEnd ? "flex-row-reverse" : "flex-row", "after::(absolute hidden pointer-events-none -left-1 -top-1 -right-1 -bottom-1)", "after::(border-2 ".concat(invert ? "border-outline-invert" : "border-outline", " ").concat(mode === "icon" || round ? "rounded-full" : "rounded-sm", " )"), variant !== "underline" && "focus-visible:after::block", (0,css/* css */.iv)(_templateObject()), className);
    var labelSizeClass = (0,hooks_esm/* useResponsiveProp */.Uo)(size, function(size) {
        if (size === "sm") return [
            "px-1.5",
            "text-sm",
            "tracking-wider"
        ];
        if (size === "base") return [
            "px-2",
            "text-base"
        ];
        if (size === "lg") return [
            "px-3",
            "text-lg"
        ];
    });
    var labelMode = (0,hooks_esm/* useResponsiveProp */.Uo)(mode, function(mode) {
        return mode === "icon" ? [
            "sr-only",
            "px-0!"
        ] : "";
    });
    var labelStyle = (0,style.tw)("relative ".concat(bold ? "font-bold" : "", " ").concat(uppercase ? "uppercase" : ""), labelSizeClass, labelMode);
    var underLineLabelSize = (0,hooks_esm/* useResponsiveProp */.Uo)(size, function(size) {
        if (size === "sm") return [
            "text-xs",
            "tracking-wider",
            "leading-4"
        ];
        if (size === "base") return [
            "text-sm",
            "leading-5"
        ];
        if (size === "lg") return [
            "text-base",
            "leading-6"
        ];
    });
    var underLineLabelMode = (0,hooks_esm/* useResponsiveProp */.Uo)(mode, function(mode) {
        return mode === "icon" ? [
            "sr-only"
        ] : "";
    });
    var underLineLabelStyle = (0,style.tw)("relative ".concat(bold ? "font-bold" : "", " ").concat(uppercase ? "uppercase" : "", " px-0"), underLineLabelSize, underLineLabelMode);
    var iconWrapperMode = (0,hooks_esm/* useResponsiveProp */.Uo)(mode, function(mode) {
        return mode === "icon" ? [
            "mr-0",
            "ml-0",
            "rtl:ml-0",
            "rtl:mr-0"
        ] : "";
    });
    var iconWrapperStyle = (0,style.tw)("relative", iconWrapperMode, loading ? "opacity-0" : "opacity-100");
    var iconSize = variant === "underline" ? "base" : getIconSizeByActionSize(size);
    var actionChildren = [
        icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            "data-uds-child": "icon",
            className: iconWrapperStyle,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                name: icon,
                size: iconSize
            })
        }, "icon") : null,
        loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,style.tw)("absolute", "text-current"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* DotAnimation */.jpF, {
                on: loading,
                size: size,
                compact: mode === "icon"
            }, "loading")
        }, "loading") : null,
        srOnlyLabel ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            "data-uds-child": "sr-only-label",
            className: "sr-only",
            children: srOnlyLabel
        }, "sr-label") : null,
        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            "data-uds-child": "text-label",
            "aria-hidden": srOnlyLabel ? "true" : "false",
            className: variant === "underline" ? underLineLabelStyle : labelStyle,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: loading ? "opacity-0" : "opacity-100",
                    children: label
                }),
                variant === "underline" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,style.tw)("h-[".concat(underlineSizeInPx, "] absolute -bottom-0.5 w-full z-0"), !invert && "bg-neutral-40", !dimmed && "group-hover:bg-neutral-100 group-focus-visible:bg-neutral-100", invert && "bg-neutral-50", invert && !dimmed && "group-hover:bg-white group-focus-visible:bg-white", className)
                }, "underline") : null
            ]
        }, "label"),
        loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "sr-only",
            children: " ".concat(t("loading").toLowerCase())
        }, "loading-sr-text") : null,
        dimmed && dimmedReason ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            "data-uds-child": "dimmed-reason",
            className: (0,style.tw)("absolute bottom-full whitespace-nowrap flex-none mb-2 px-2 py-1 bg-neutral-100 rounded-sm text-white ".concat(bold ? "font-bold" : "", " text-xs ").concat(uppercase ? "uppercase" : ""), "opacity-0 invisible group-hover:(opacity-100 visible) group-focus-visible:(opacity-100 visible)"),
            children: dimmedReason
        }, "dimmed-reason") : null, 
    ];
    return {
        className: actionClassName,
        children: actionChildren,
        "aria-disabled": dimmed || undefined
    };
};

;// CONCATENATED MODULE: ./UDS/elements/action-cta/ButtonCta.tsx





/**
 * The `ButtonCta` component renders a `button` tag, and is used to
 * submit forms, or receive user input. For navigation it is recommended
 * to use the `LinkCta` component.
 *
 * @example
 * ```
 * <ButtonCta label="Shop Running" />
 * ```
 */ var ButtonCta = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function ButtonCta(props, forwardedRef) {
    var dataTestId = props.dataTestId, label = props.label, srOnlyLabel = props.srOnlyLabel, variant = props.variant, invert = props.invert, size = props.size, color = props.color, mode = props.mode, bleed = props.bleed, round = props.round, dimmed = props.dimmed, dimmedReason = props.dimmedReason, disabled = props.disabled, icon = props.icon, iconEnd = props.iconEnd, loading = props.loading, className = props.className, onClick = props.onClick, _type = props.type, type = _type === void 0 ? "button" : _type, rest = _object_without_properties(props, [
        "dataTestId",
        "label",
        "srOnlyLabel",
        "variant",
        "invert",
        "size",
        "color",
        "mode",
        "bleed",
        "round",
        "dimmed",
        "dimmedReason",
        "disabled",
        "icon",
        "iconEnd",
        "loading",
        "className",
        "onClick",
        "type"
    ]);
    var actionCtaProps = useActionCta({
        className: className,
        label: label,
        srOnlyLabel: srOnlyLabel,
        variant: variant,
        invert: invert,
        size: size,
        color: color,
        mode: mode,
        round: round,
        bleed: bleed,
        dimmed: dimmed || disabled,
        dimmedReason: dimmedReason,
        icon: icon,
        iconEnd: iconEnd,
        loading: loading
    });
    var handleOnClick = function(e) {
        if (loading) {
            e.preventDefault();
            return;
        }
        if (onClick) {
            onClick(e);
        }
    };
    return /*#__PURE__*/ _jsx("button", _object_spread({
        ref: forwardedRef,
        "data-test-id": dataTestId,
        onClick: handleOnClick,
        disabled: disabled,
        // eslint-disable-next-line react/button-has-type
        type: type
    }, actionCtaProps, rest));
})));
// Temporarily export both ButtonCta and Button whilst we migrate to ButtonCta
var Button = (/* unused pure expression or super */ null && (ButtonCta));

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(31373);
;// CONCATENATED MODULE: ./UDS/elements/action-cta/LinkCta.tsx







/**
 * LinkCta is a link that is styled as a rectangle call-to-action, identical to the `ButtonCta` element
 *
 * @example
 * ```
 * <LinkCta label="Shop Running" href="/running" />
 * ```
 */ var LinkCta = /*#__PURE__*/ react.forwardRef(function LinkCta(props, forwardedRef) {
    var label = props.label, srOnlyLabel = props.srOnlyLabel, className = props.className, variant = props.variant, invert = props.invert, size = props.size, color = props.color, mode = props.mode, round = props.round, bleed = props.bleed, dimmed = props.dimmed, icon = props.icon, iconEnd = props.iconEnd, loading = props.loading, uppercase = props.uppercase, bold = props.bold, underlineSizeInPx = props.underlineSizeInPx, dataTestId = props.dataTestId, rest = (0,src_object_without_properties/* default */.Z)(props, [
        "label",
        "srOnlyLabel",
        "className",
        "variant",
        "invert",
        "size",
        "color",
        "mode",
        "round",
        "bleed",
        "dimmed",
        "icon",
        "iconEnd",
        "loading",
        "uppercase",
        "bold",
        "underlineSizeInPx",
        "dataTestId"
    ]);
    var actionCtaProps = useActionCta_useActionCta({
        label: label,
        srOnlyLabel: srOnlyLabel,
        className: className,
        variant: variant,
        invert: invert,
        size: size,
        color: color,
        mode: mode,
        round: round,
        bleed: bleed,
        dimmed: dimmed,
        icon: icon,
        iconEnd: iconEnd,
        loading: loading,
        uppercase: uppercase,
        bold: bold,
        underlineSizeInPx: underlineSizeInPx
    });
    var navigateProps = (0,hooks_esm/* useNavigate */.s0)(rest);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        ref: forwardedRef
    }, actionCtaProps, navigateProps), {
        "data-test-id": dataTestId
    }));
});
// Temporarily export both LinkCta and Link whilst we migrate to LinkCta
var Link = LinkCta;

;// CONCATENATED MODULE: ./UDS/elements/action-cta/index.tsx



// EXTERNAL MODULE: ./hooks/useMiniCart.tsx
var useMiniCart = __webpack_require__(38859);
// EXTERNAL MODULE: ./utils/media.ts
var media = __webpack_require__(39772);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./hooks/usePageEventsContext.tsx
var usePageEventsContext = __webpack_require__(43308);
// EXTERNAL MODULE: ./utils/analytics/index.ts + 6 modules
var analytics = __webpack_require__(83168);
// EXTERNAL MODULE: ./ui/elements/Link.tsx
var elements_Link = __webpack_require__(68302);
// EXTERNAL MODULE: ./utils/buildProductUrl.ts
var buildProductUrl = __webpack_require__(69377);
// EXTERNAL MODULE: ./utils/products.ts
var products = __webpack_require__(1032);
// EXTERNAL MODULE: ./ui/components/ProductListItemImages.tsx
var ProductListItemImages = __webpack_require__(45876);
// EXTERNAL MODULE: ./ui/components/Sizes/index.ts + 9 modules
var Sizes = __webpack_require__(38913);
// EXTERNAL MODULE: ./ui/components/Styles.tsx
var Styles = __webpack_require__(87260);
// EXTERNAL MODULE: ./ui/components/Skeleton.tsx
var Skeleton = __webpack_require__(98463);
;// CONCATENATED MODULE: ./ui/components/GiftWithPurchase/NewDesign/GWP.new.ColorPicker.tsx









var GWPNew_ColorPicker = function(param) {
    var variations = param.variations, selectedVariant = param.selectedVariant, setSelectedVariant = param.setSelectedVariant, productName = param.productName, productId = param.productId;
    var ref;
    var translate = (0,useTranslations/* useTranslate */.qM)();
    var ref1 = (0,react.useState)(), desiredSwatch = ref1[0], setDesiredSwatch = ref1[1];
    (0,react.useEffect)(function() {
        // when product is changed -> set the swatch of the first selectedVariant
        setDesiredSwatch(variations[0].id.split("_")[1]);
    }, [
        variations
    ]);
    var sizes = selectedVariant ? (0,products/* getSizesFromSizeGroups */.hJ)(selectedVariant.sizeGroups) : [];
    var pageviewEventHasFired = (0,usePageEventsContext/* usePageEventsContext */.qN)().pageviewEventHasFired;
    var onChangeStyle = (0,react.useCallback)(function(swatch) {
        setDesiredSwatch(swatch);
        var desiredVariant = variations.find(function(v) {
            return v.id.split("_")[1] === swatch;
        });
        if (desiredVariant) {
            setSelectedVariant(desiredVariant);
            if (pageviewEventHasFired) {
                (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
                    event_name: analytics/* AnalyticsEvents.CHANGE_COLOR */._q.CHANGE_COLOR,
                    event_params: {
                        item_id_ep: desiredVariant === null || desiredVariant === void 0 ? void 0 : desiredVariant.id,
                        item_name_ep: productName,
                        color_code_ep: "a".concat(desiredVariant === null || desiredVariant === void 0 ? void 0 : desiredVariant.colorValue),
                        style_number_ep: productId,
                        is_gift: "true"
                    }
                });
            }
        }
    }, [
        pageviewEventHasFired,
        productId,
        productName,
        setSelectedVariant,
        variations, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
                gap: "xs",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Heading */.X6q, {
                        asChild: true,
                        size: "sm",
                        weight: "bold",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: translate("color")
                        })
                    }),
                    (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.colorName) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Heading */.X6q, {
                        asChild: true,
                        size: "xxxs",
                        weight: "normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                            children: [
                                selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.colorName,
                                " ",
                                !selectedVariant.orderable && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "sr-only",
                                    children: [
                                        ":",
                                        " ",
                                        (selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.displayOutOfStock) === null || ref === void 0 ? void 0 : ref.displayValue) || translate("soldOut")
                                    ]
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                        className: "mt-2 w-24 h-4"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Styles/* Styles */.z, {
                desiredSwatch: desiredSwatch,
                onChange: onChangeStyle,
                variations: variations,
                isHydrating: sizes.length === 0
            })
        ]
    });
};

;// CONCATENATED MODULE: ./ui/components/GiftWithPurchase/NewDesign/GWP.new.Product.tsx












var GWPNew_Product = function(param) {
    var selectedProduct = param.selectedProduct, selectedVariant = param.selectedVariant, setSelectedVariant = param.setSelectedVariant, selectedSize = param.selectedSize, setSelectedSize = param.setSelectedSize;
    var setModalOpen = (0,store/* useModalsOpenStore */.wQ)().setModalOpen;
    var variations = selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.variations;
    var pageviewEventHasFired = (0,usePageEventsContext/* usePageEventsContext */.qN)().pageviewEventHasFired;
    (0,react.useEffect)(function() {
        // when the product (variations) is changed
        // -> set the first variation as the selected one
        // -> reset the selected size to undefined
        setSelectedVariant(variations === null || variations === void 0 ? void 0 : variations[0]);
        setSelectedSize(undefined);
    }, [
        setSelectedSize,
        setSelectedVariant,
        variations
    ]);
    if (!selectedProduct || !selectedVariant) return null;
    var triggerEventChooseSize = function(param) {
        var productName = param.productName, variantId = param.variantId;
        if (pageviewEventHasFired) {
            (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
                event_name: analytics/* AnalyticsEvents.CHOOSE_SIZE */._q.CHOOSE_SIZE,
                event_params: {
                    item_id_ep: variantId,
                    item_name_ep: productName,
                    is_gift: "true"
                }
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
        gap: "sm",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListItemImages/* ProductListItemImages */.X, {
                variant: selectedVariant
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_Link/* Link */.r, {
                href: (0,buildProductUrl/* buildProductUrl */.B)(selectedProduct.id, selectedProduct.name, {
                    swatch: selectedVariant.colorValue
                }),
                onClick: function() {
                    return setModalOpen("GWPModal", false);
                },
                className: "hover:underline hover:cursor-pointer font-bold text-xl",
                children: selectedProduct.name
            }),
            variations && /*#__PURE__*/ (0,jsx_runtime.jsx)(GWPNew_ColorPicker, {
                variations: variations,
                selectedVariant: selectedVariant,
                setSelectedVariant: setSelectedVariant,
                productName: selectedProduct.name,
                productId: selectedProduct.id
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-0.5 bg-gray-300 opacity-50 my-2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Sizes/* Sizes */.u8, {
                sizeGroups: selectedVariant.sizeGroups,
                desiredSize: selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.id,
                onChange: function(sizeId) {
                    var desiredSize = getDesiredSize({
                        variant: selectedVariant,
                        sizeId: sizeId
                    });
                    setSelectedSize(desiredSize);
                    triggerEventChooseSize({
                        productName: selectedProduct.name,
                        variantId: selectedVariant.id
                    });
                }
            })
        ]
    });
};
// ──── UTILS FOR ONLY THIS FILE ─────────────────────────────────────────────────────────────────────────
var getDesiredSize = function(param) {
    var variant = param.variant, sizeId = param.sizeId;
    var sizes = (0,products/* getSizesFromSizeGroups */.hJ)(variant.sizeGroups);
    var desiredSize = sizes.find(function(size) {
        return size.id === sizeId;
    });
    return desiredSize;
};

// EXTERNAL MODULE: ../node_modules/twind/twind.js + 1 modules
var twind = __webpack_require__(34209);
// EXTERNAL MODULE: ./utils/image.ts
var utils_image = __webpack_require__(75350);
// EXTERNAL MODULE: ./ui/components/Img.tsx
var Img = __webpack_require__(53579);
;// CONCATENATED MODULE: ./ui/components/GiftWithPurchase/NewDesign/GWP.new.ProductSelector.tsx








var GWPNew_ProductSelector = function(param) {
    var setCurrentItem = param.setCurrentItem, currentItem = param.currentItem, items = param.items;
    var pageviewEventHasFired = (0,usePageEventsContext/* usePageEventsContext */.qN)().pageviewEventHasFired;
    var triggerEventSelectProductOverlay = function(product) {
        if (pageviewEventHasFired) {
            var ref;
            (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
                event_name: analytics/* AnalyticsEvents.GA4_SELECT_PRODUCT_OVERLAY */._q.GA4_SELECT_PRODUCT_OVERLAY,
                event_params: {
                    item_id_ep: (ref = product === null || product === void 0 ? void 0 : product.variations[0]) === null || ref === void 0 ? void 0 : ref.id,
                    item_name_ep: product === null || product === void 0 ? void 0 : product.name
                }
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Stack */.Kqy, {
        direction: "inline",
        gap: "xs",
        className: "justify-center my-4",
        children: items.map(function(product) {
            var productImage = product.variations[0].images[0];
            var isCurrentItem = product.id === (currentItem === null || currentItem === void 0 ? void 0 : currentItem.id);
            var _alt;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-16 flex-none transform-gpu",
                "data-test-id": "product-selector-gwp-modal",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Img/* Img */.E, {
                    src: (0,utils_image/* resizeProductImage */.QW)(productImage.href, 128, "2000"),
                    alt: (_alt = productImage.alt) !== null && _alt !== void 0 ? _alt : "",
                    title: productImage.alt,
                    className: (0,twind.tw)([
                        isCurrentItem && "border border-puma-black-200 rounded-sm", 
                    ]),
                    onClick: function() {
                        setCurrentItem(product);
                        triggerEventSelectProductOverlay(product);
                    }
                })
            }, product.id);
        })
    });
};

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ./hooks/useCart.ts
var useCart = __webpack_require__(69771);
// EXTERNAL MODULE: ./ui/components/AddToCartButton.tsx + 3 modules
var AddToCartButton = __webpack_require__(56202);
;// CONCATENATED MODULE: ./ui/components/GiftWithPurchase/NewDesign/GWP.new.AddToCartButton.tsx










var GWPNew_AddToCartButton = function(param) {
    var selectedSize = param.selectedSize, selectedVariant = param.selectedVariant, gwpId = param.gwpId;
    var ref;
    var openMiniCart = (0,useMiniCart/* useMiniCart */.lm)().openMiniCart;
    var addToCart = (0,useCart/* useCart */.j)().addToCart;
    var setModalOpen = (0,store/* useModalsOpenStore */.wQ)().setModalOpen;
    var setPopupOpen = (0,store/* usePopupsOpenStore */.Gd)().setPopupOpen;
    var router = (0,next_router.useRouter)();
    var getTempState = (0,store/* useTempStateStore */.nx)().getTempState;
    var ref1 = (0,react.useState)(false), addingToCart = ref1[0], setAddingToCart = ref1[1];
    var isCartPage = router.asPath.includes("/cart");
    var onAddToCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, addItemsToCart, _tmp, cartProducts, lastProductAddedToTheCart, gwpProduct;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!selectedSize || !selectedVariant) return [
                            2,
                            null
                        ];
                        setAddingToCart(true);
                        _tmp = {};
                        return [
                            4,
                            addToCart((_tmp.productId = selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.productId, _tmp.bonusItemId = gwpId, _tmp.quantity = 1, _tmp.swatch = selectedVariant.colorValue, _tmp.masterId = selectedVariant.id.split("_")[0], _tmp), undefined, // NOTE:  inside this function the miniCart opens only with the last product added,
                            //        so we don't want to open the miniCart from here because we want to open
                            //        the miniCart with 2 products (original item + gwp item)
                            false, router.asPath)
                        ];
                    case 1:
                        addItemsToCart = (ref = _state.sent().data) === null || ref === void 0 ? void 0 : ref.addItemsToCart;
                        setAddingToCart(false);
                        setModalOpen("GWPModal", false);
                        // don't try to open popup or miniCart when user is on Cart page
                        if (!isCartPage) {
                            if ((0,media/* getIsMobile */.W)()) {
                                // in mobile open popUp
                                setPopupOpen("CartButtonPopup", true);
                            } else {
                                cartProducts = addItemsToCart === null || addItemsToCart === void 0 ? void 0 : addItemsToCart.products;
                                lastProductAddedToTheCart = cartProducts === null || cartProducts === void 0 ? void 0 : cartProducts.find(function(p) {
                                    return p.product.id === getTempState("IdOfLastProductAddedToCart");
                                });
                                gwpProduct = cartProducts === null || cartProducts === void 0 ? void 0 : cartProducts.find(function(p) {
                                    return p.bonusItemId === gwpId;
                                });
                                if (lastProductAddedToTheCart && gwpProduct) {
                                    openMiniCart([
                                        lastProductAddedToTheCart,
                                        gwpProduct
                                    ], true);
                                }
                            }
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onAddToCart() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCartButton/* AddToCartButton */.a, {
        disabled: !(selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.orderable) || !selectedVariant,
        isAppExclusive: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.isAppExclusive,
        loading: addingToCart,
        onAddToCart: onAddToCart,
        presale: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.displayOutOfStock) === null || ref === void 0 ? void 0 : ref.presale,
        size: "lg",
        appOnlyDateTimeFrom: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.appOnlyDateTimeFrom,
        appOnlyDateTimeTo: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.appOnlyDateTimeTo
    });
};

;// CONCATENATED MODULE: ./ui/components/GiftWithPurchase/NewDesign/GWP.new.Modal.tsx





 // our modified clone of UDS.Link component - TODO: later consume this from our "UDS" repo








var GWPNew_Modal = function(param) {
    var cart = param.cart;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var router = (0,next_router.useRouter)();
    var setModalOpen = (0,store/* useModalsOpenStore */.wQ)().setModalOpen;
    var openMiniCart = (0,useMiniCart/* useMiniCart */.lm)().openMiniCart;
    var setPopupOpen = (0,store/* usePopupsOpenStore */.Gd)().setPopupOpen;
    var pageviewEventHasFired = (0,usePageEventsContext/* usePageEventsContext */.qN)().pageviewEventHasFired;
    var getTempState = (0,store/* useTempStateStore */.nx)().getTempState;
    var ref = (0,react.useState)(), selectedProduct = ref[0], setSelectedProduct = ref[1];
    var ref1 = (0,react.useState)(), selectedVariant = ref1[0], setSelectedVariant = ref1[1];
    var ref2 = (0,react.useState)(), selectedSize = ref2[0], setSelectedSize = ref2[1];
    var lastGWPAdded = cart === null || cart === void 0 ? void 0 : cart.giftWithPurchases[(cart === null || cart === void 0 ? void 0 : cart.giftWithPurchases.length) - 1];
    var products = lastGWPAdded === null || lastGWPAdded === void 0 ? void 0 : lastGWPAdded.availableProducts.filter(function(a) {
        return a.__typename === "ProductWithExclusion";
    }).map(function(a) {
        return a.product;
    });
    // set the first available product as selected product
    (0,react.useEffect)(function() {
        if (!selectedProduct) {
            if ((lastGWPAdded === null || lastGWPAdded === void 0 ? void 0 : lastGWPAdded.availableProducts[0].__typename) === "ProductWithExclusion") {
                setSelectedProduct(lastGWPAdded === null || lastGWPAdded === void 0 ? void 0 : lastGWPAdded.availableProducts[0].product);
            }
        }
    }, [
        selectedProduct,
        lastGWPAdded
    ]);
    var openPopupOrMiniCartAfterClosingModal = (0,react.useCallback)(function() {
        // don't try to open popup or miniCart when user is on Cart page
        if (!router.asPath.includes("/cart")) {
            if ((0,media/* getIsMobile */.W)()) {
                // in mobile show cart-button-popup
                setPopupOpen("CartButtonPopup", true);
            } else {
                var ref;
                // in desktop show mini-cart with the last item added to the cart
                // NOTE:  we need to use the `getTempState('IdOfLastProductAddedToCart')` function
                //        to filter the product in the cart by this id, because when we add the
                //        same product in the cart for the 2nd time and with another product in
                //        between, we only are updating the quantity field and no "adding" new item
                //        to the array of product objects. So we cannot get the last item of the
                //        cart by trying to get the last item of the array.
                var lastProductAddedToTheCart = (ref = cart === null || cart === void 0 ? void 0 : cart.products) === null || ref === void 0 ? void 0 : ref.find(function(p) {
                    return p.product.id === getTempState("IdOfLastProductAddedToCart");
                });
                if (lastProductAddedToTheCart) openMiniCart(lastProductAddedToTheCart, true);
            }
        }
    }, [
        cart === null || cart === void 0 ? void 0 : cart.products,
        getTempState,
        openMiniCart,
        router.asPath,
        setPopupOpen
    ]);
    (0,react.useEffect)(function() {
        if (pageviewEventHasFired) {
            (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
                event_name: analytics/* AnalyticsEvents.GA4_OVERLAY_VIEW */._q.GA4_OVERLAY_VIEW
            });
        }
    }, [
        pageviewEventHasFired
    ]);
    if (!(selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.variations) || !selectedProduct.name || !(lastGWPAdded === null || lastGWPAdded === void 0 ? void 0 : lastGWPAdded.id)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* DialogRoot */.GRm, {
        dataTestId: "gwp-new-modal",
        size: {
            _: "full",
            xs: "sm"
        },
        drawer: {
            _: false,
            xs: true
        },
        justify: "end",
        open: true,
        onOpenChange: function(open) {
            // the modal doesn't open from here, so only handle close-logic
            if (!open) {
                setModalOpen("GWPModal", false);
                openPopupOrMiniCartAfterClosingModal();
            }
        },
        autoFocus: "content",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* DialogContent */.cZJ, {
            onInteractOutside: openPopupOrMiniCartAfterClosingModal,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* DialogHeader */.fKu, {
                    className: "min-h-[75px] pr-7 flex flex-col",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* DialogHeading */.EtB, {
                            children: lastGWPAdded === null || lastGWPAdded === void 0 ? void 0 : lastGWPAdded.gwpTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Heading */.X6q, {
                            asChild: true,
                            size: "xxs",
                            weight: "normal",
                            className: "mt-2",
                            children: t("giftWithPurchaseModalSelectYourItems")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* DialogBody */.a7O, {
                    className: "overflow-y-auto overflow-x-hidden",
                    children: [
                        products && products.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GWPNew_ProductSelector, {
                            currentItem: selectedProduct,
                            setCurrentItem: setSelectedProduct,
                            items: products
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GWPNew_Product, {
                            selectedProduct: selectedProduct,
                            selectedVariant: selectedVariant,
                            setSelectedVariant: setSelectedVariant,
                            selectedSize: selectedSize,
                            setSelectedSize: setSelectedSize
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mb-2 flex justify-center flex-col p-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GWPNew_AddToCartButton, {
                            gwpId: lastGWPAdded === null || lastGWPAdded === void 0 ? void 0 : lastGWPAdded.id,
                            selectedSize: selectedSize,
                            selectedVariant: selectedVariant
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                            variant: "underline",
                            href: "/puma/sale-terms-and-conditions",
                            target: "_blank" // open new tab
                            ,
                            label: t("termsAmpersandConditions"),
                            className: "text-gray-500 hover:text-black",
                            uppercase: false,
                            bold: false,
                            underlineSizeInPx: "1px",
                            size: "lg"
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./hooks/useFeature.ts
var useFeature = __webpack_require__(53625);
;// CONCATENATED MODULE: ./ui/components/GiftWithPurchase/NewDesign/GWP.new.CalloutButton.tsx




var GWPNew_CalloutButton = function(param) {
    var className = param.className, onClick = param.onClick;
    var hideCalloutMessage = (0,useFeature/* useFeature */.S)("HIDE_CALLOUT_MESSAGE");
    var t = (0,useTranslations/* useTranslate */.qM)();
    var promoCalloutMessage = !hideCalloutMessage ? t("claimYourGiftItems") : t("bonusItems");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ButtonCta */.NlM, {
        dataTestId: "gwp-promo-link",
        className: className,
        onClick: onClick,
        icon: "gift",
        size: "sm",
        label: promoCalloutMessage,
        variant: "secondary"
    });
};

;// CONCATENATED MODULE: ./ui/components/GiftWithPurchase/NewDesign/index.ts






var GWPNewDesign = {
    Modal: GWPNew_Modal,
    Product: GWPNew_Product,
    ColorPicker: GWPNew_ColorPicker,
    ProductSelector: GWPNew_ProductSelector,
    AddToCartButton: GWPNew_AddToCartButton,
    CalloutButton: GWPNew_CalloutButton
};


/***/ }),

/***/ 56620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ MixedCartErrorMessage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12601);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27378);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77480);
/* harmony import */ var hooks_useMiniCart__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38859);






var MixedCartErrorMessage = function(param) {
    var mixedCartNotAllowed = param.mixedCartNotAllowed;
    var isMiniCartVisible = (0,hooks_useMiniCart__WEBPACK_IMPORTED_MODULE_5__/* .useMiniCart */ .lm)().isMiniCartVisible;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_4__/* .useTranslate */ .qM)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(window.matchMedia("(max-width: 604px)").matches), isMobile = ref[0], setIsMobile = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var handleResize = function() {
            setIsMobile(window.matchMedia("(max-width: 604px)").matches);
        };
        window.addEventListener("resize", handleResize);
        return function() {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    var isPdp = router.asPath.includes("pd");
    var errorMessage = isPdp && !isMiniCartVisible ? t("mixedCartPdpError") : t("mixedCartError");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: mixedCartNotAllowed && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .Alert */ .bZj, {
                dataTestId: "mixed-cart-mobile-error",
                className: "px-[12px] py-[8px] text-sm",
                variant: "error",
                content: errorMessage
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                "data-test-id": "mixed-cart-error-message",
                className: "md:col-span-2 px-[12px] py-[8px] border-[1px] rounded-[2px] border-error-20 text-error-50 text-sm font-bold flex flex-row justify-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: errorMessage
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO$, {
                        size: "2xl",
                        name: "exclamation-filled"
                    })
                ]
            })
        })
    });
};


/***/ })

}]);